import { Database } from '@my/supabase/types'

import { useSupabaseClient } from './SessionContext'

export const useSupabase = () => {
  return useSupabaseClient<Database>()
}
